import {Component} from "react";

const React = require('react');

class DebugLogForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };
  }

  componentDidMount() {
    fetch('/occupancy/debug?operation_id=' + this.props.operationId, {
      headers: { 'Authorization': 'Bearer ' + this.props.token }
    })
        .then(response => response.json())
        .then(data => this.setState({data}));
  }

  render() {
    if (!this.state.data || this.state.data.err) { return 'Loading'; }

    let { data } = this.state;
    let { maxOccupancy,  criticalOccupancy } = this.state.data;

    let rows = data.dates.map( (time, i) => {
      let row = data.values[i];
      time = new Date(time);
      let forced = [...row.forcedOccupancy];

      return <tr key={i}>
        <th>{time.getHours() + ':' + ('0' + time.getMinutes()).slice(-2)}</th>
        <td>{row.in !== 0 && row.in}</td>
        <td>{row.out !== 0 && row.out}</td>
        <td>{row.artificialIn !== 0 && row.artificialIn}</td>
        <td>{row.artificialOut !== 0 && row.artificialOut}</td>
        <td>{row.forcedOccupancy && forced.reverse().join(", ")}</td>
      </tr>;
    });

    return <div className="modal active" id="modal-id">
      <a href='#' onClick={this.props.closeModal} className="modal-overlay" aria-label="Close"> </a>
      <div className="modal-container">
        <div className="modal-header">
          <a onClick={this.props.closeModal} className="btn btn-clear float-right" aria-label="Close"/>
          <div className="modal-title h5">Debug Log</div>
        </div>
        <div className="modal-body">
          <div className="content text-left">
            Max in-out mapping threshold: {data.maxVisitDurationSeconds / 60} minutes.<br />
            Max occupancy: {maxOccupancy || 'Unconfigured'}.<br />
            Critical occupancy: {criticalOccupancy || 'Unconfigured'}.<br />
            <table className='table'>
              <thead>
              <tr>
                <th>Time</th>
                <th>In</th>
                <th>Out</th>
                <th>Artificial in</th>
                <th>Artificial out</th>
                <th>Forced in</th>
              </tr>
              </thead>
              <tbody>
              {rows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
  }


}

class  DebugLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      setOpen: this.setOpen.bind(this)
    }
  }

  setOpen(value) {
    this.setState({open: value});
  }

  render() {
    let {open, setOpen} = this.state;
    if (open) {
      return <DebugLogForm closeModal={() => setOpen(false)} {...this.props}/>
    } else {
      return <button onClick={() => setOpen(true)} className='btn btn-sm btn-link'>?</button>;
    }
  }
}

export default DebugLog;
